import { Button } from "@/Components/ui/button";
import { useIsMobile } from "./use-mobile";

export interface ConfirmationProps {
  onConfirm: () => void;
  onCancel: () => void;
  content?: JSX.Element;
  confirmText?: string;
  cancelText?: string;
  confirmColour?: string;
  cancelColour?: string;
}

const Confirmation = ({ onConfirm, onCancel, confirmColour, cancelColour, confirmText, cancelText, content }: ConfirmationProps) => {
  const isMobile = useIsMobile();
  return (
    <div>
      {content}
      <div className="flex justify-between items-center w-[250px] mx-auto">
        <Button
          className={(cancelColour ? cancelColour
            : "bg-gray-500") + (isMobile ? " text-2xl p-6" : " px-4 py-2") + " text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 rounded mr-4 ml-2"}
          onClick={() => onCancel()}
        >
          {cancelText ? cancelText : "Cancel"}
        </Button>
        <Button
          className={(confirmColour ? confirmColour
            : "bg-blue-500") + (isMobile ? " text-2xl p-6" : " px-4 py-2") + " text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded"}
          onClick={() => onConfirm()}
        >
          {confirmText ? confirmText : "Confirm"}
        </Button>
      </div>
    </div>
  )
}

export default Confirmation